import { defineMessages } from 'react-intl';

/**
 * MV2-577 Part 2 (3.4) — Business & Finance → Trainer earnings. Calculated
 * fees, not a payroll statement: no text here may say that a fee has been
 * paid or that a period is closed (Part 2 tracks no payout).
 */
export default defineMessages({
  title: {
    id: 'businessFinance.trainerEarnings.title',
    defaultMessage: 'Trainer earnings',
  },
  subtitle: {
    id: 'businessFinance.trainerEarnings.subtitle',
    defaultMessage:
      'Trainer fees calculated from membership payments and held group sessions, per trainer and currency',
  },
  granularityLabel: {
    id: 'businessFinance.trainerEarnings.granularityLabel',
    defaultMessage: 'Group by',
  },
  granularityMonth: {
    id: 'businessFinance.trainerEarnings.granularityMonth',
    defaultMessage: 'Month',
  },
  granularityWeek: {
    id: 'businessFinance.trainerEarnings.granularityWeek',
    defaultMessage: 'Week',
  },
  weekOf: {
    id: 'businessFinance.trainerEarnings.weekOf',
    defaultMessage: 'Week of {date}',
  },
  columnTrainer: {
    id: 'businessFinance.trainerEarnings.columnTrainer',
    defaultMessage: 'Trainer',
  },
  columnCurrency: {
    id: 'businessFinance.trainerEarnings.columnCurrency',
    defaultMessage: 'Currency',
  },
  columnMemberships: {
    id: 'businessFinance.trainerEarnings.columnMemberships',
    defaultMessage: 'Memberships',
  },
  columnSessions: {
    id: 'businessFinance.trainerEarnings.columnSessions',
    defaultMessage: 'Sessions',
  },
  columnTotal: {
    id: 'businessFinance.trainerEarnings.columnTotal',
    defaultMessage: 'Total',
  },
  openRow: {
    id: 'businessFinance.trainerEarnings.openRow',
    defaultMessage: 'Show the fee lines of {trainer}, {period}, {currency}',
  },
  empty: {
    id: 'businessFinance.trainerEarnings.empty',
    defaultMessage: 'No trainer fees in this period.',
  },
  loadError: {
    id: 'businessFinance.trainerEarnings.loadError',
    defaultMessage: 'Trainer earnings could not be loaded.',
  },
  retry: {
    id: 'businessFinance.trainerEarnings.retry',
    defaultMessage: 'Try again',
  },
  unpriced: {
    id: 'businessFinance.trainerEarnings.unpriced',
    defaultMessage:
      '{count, plural, one {# payment affecting this period has} other {# payments affecting this period have}} no computed trainer fee — contact support',
  },
  hintTitle: {
    id: 'businessFinance.trainerEarnings.hintTitle',
    defaultMessage:
      'How these figures are calculated — calculated fees, not a payroll statement',
  },
  hintMembershipFrozen: {
    id: 'businessFinance.trainerEarnings.hintMembershipFrozen',
    defaultMessage:
      'A membership fee is fixed when the payment is recorded and counts in the period of that payment.',
  },
  hintRefundPeriod: {
    id: 'businessFinance.trainerEarnings.hintRefundPeriod',
    defaultMessage:
      'A refund, dispute or reversal changes the fee in the period of the refund, not the period of the original payment.',
  },
  hintSessionsProvisional: {
    id: 'businessFinance.trainerEarnings.hintSessionsProvisional',
    defaultMessage:
      'A group session counts from its start and stays provisional: a later change of its fee or trainer, or its cancellation, may change past totals.',
  },
  hintSubstitutes: {
    id: 'businessFinance.trainerEarnings.hintSubstitutes',
    defaultMessage:
      'A substitute trainer is corrected manually in Profits & Expenses.',
  },
  hintCutover: {
    id: 'businessFinance.trainerEarnings.hintCutover',
    defaultMessage:
      'Payments recorded before trainer fees were tracked are not included.',
  },
  drawerRange: {
    id: 'businessFinance.trainerEarnings.drawerRange',
    defaultMessage: '{from} – {to} · {currency}',
  },
  close: {
    id: 'businessFinance.trainerEarnings.close',
    defaultMessage: 'Close',
  },
  itemColumnDate: {
    id: 'businessFinance.trainerEarnings.itemColumnDate',
    defaultMessage: 'Date',
  },
  itemColumnKind: {
    id: 'businessFinance.trainerEarnings.itemColumnKind',
    defaultMessage: 'Type',
  },
  itemColumnSubject: {
    id: 'businessFinance.trainerEarnings.itemColumnSubject',
    defaultMessage: 'Client or session',
  },
  itemColumnFee: {
    id: 'businessFinance.trainerEarnings.itemColumnFee',
    defaultMessage: 'Fee',
  },
  kindMembershipPayment: {
    id: 'businessFinance.trainerEarnings.kindMembershipPayment',
    defaultMessage: 'Membership payment',
  },
  kindMembershipRefund: {
    id: 'businessFinance.trainerEarnings.kindMembershipRefund',
    defaultMessage: 'Refund',
  },
  kindMembershipDispute: {
    id: 'businessFinance.trainerEarnings.kindMembershipDispute',
    defaultMessage: 'Dispute',
  },
  kindMembershipRefundReversal: {
    id: 'businessFinance.trainerEarnings.kindMembershipRefundReversal',
    defaultMessage: 'Refund reversal',
  },
  kindSession: {
    id: 'businessFinance.trainerEarnings.kindSession',
    defaultMessage: 'Group session',
  },
  openClient: {
    id: 'businessFinance.trainerEarnings.openClient',
    defaultMessage: 'Client profile',
  },
  untitledSession: {
    id: 'businessFinance.trainerEarnings.untitledSession',
    defaultMessage: 'Untitled session',
  },
  itemsEmpty: {
    id: 'businessFinance.trainerEarnings.itemsEmpty',
    defaultMessage: 'No fee lines for this row.',
  },
  itemsLoadError: {
    id: 'businessFinance.trainerEarnings.itemsLoadError',
    defaultMessage: 'The fee lines could not be loaded.',
  },
  itemsPage: {
    id: 'businessFinance.trainerEarnings.itemsPage',
    defaultMessage: '{first}–{last} of {total}',
  },
  previousPage: {
    id: 'businessFinance.trainerEarnings.previousPage',
    defaultMessage: 'Previous',
  },
  nextPage: {
    id: 'businessFinance.trainerEarnings.nextPage',
    defaultMessage: 'Next',
  },
});
